/* global trapFocus, removeTrapFocus */

/**
 * Accessibility patch for the Quick Buy panel (theme.quickBuy in main.js).
 * Quick Buy already dispatches on:quickbuy:before-open / on:quickbuy:after-open
 * on the .quickbuy-container element on every open, and already has a working
 * close control (.close-detail). This adds the dialog semantics, focus trap
 * and Escape-to-close that main.js does not, reusing the same
 * trapFocus/removeTrapFocus helpers cart-drawer already relies on.
 *
 * Note: main.js only dispatches on:quickbuy:after-close when a panel is
 * force-closed because a different one is opening elsewhere -- not on a
 * normal user-initiated close (X button or Escape). So instead of relying on
 * that event, this watches for the one thing that happens on every close:
 * the product-block losing its "expanded" class.
 */
(function () {
  var quickbuyOpener = null;

  function cleanup(container) {
    container.removeAttribute('role');
    container.removeAttribute('aria-modal');
    container.removeAttribute('aria-label');

    if (container.quickbuyEscapeHandler) {
      container.removeEventListener('keydown', container.quickbuyEscapeHandler);
      container.quickbuyEscapeHandler = null;
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(quickbuyOpener);
    } else if (quickbuyOpener) {
      quickbuyOpener.focus();
    }
  }

  function findContainer(block) {
    return block.querySelector('.quickbuy-container')
      || (block.closest('.collection-slider-row')
        && block.closest('.collection-slider-row').querySelector('.quickbuy-container'));
  }

  document.addEventListener('click', function (evt) {
    var toggle = evt.target.closest('.quickbuy-toggle');
    if (toggle) quickbuyOpener = toggle;
  });

  document.addEventListener('on:quickbuy:after-open', function (evt) {
    var container = evt.target;
    var closeBtn = container.querySelector('.close-detail');

    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    container.setAttribute('aria-label', 'Quick buy');

    container.quickbuyEscapeHandler = function (e) {
      if (e.key === 'Escape' && closeBtn) closeBtn.click();
    };
    container.addEventListener('keydown', container.quickbuyEscapeHandler);

    if (typeof trapFocus === 'function') {
      trapFocus(container, closeBtn || container);
    } else if (closeBtn) {
      closeBtn.focus();
    }
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var block = m.target;
      if (!block.classList || !block.classList.contains('product-block')) return;
      if (block.classList.contains('expanded')) return;

      var container = findContainer(block);
      if (container && container.getAttribute('role') === 'dialog') cleanup(container);
    });
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
})();